import { NORMAN } from 'HubStyleTokens/colors';
const NOTIFICATION_BACKGROUND_COLOR = NORMAN;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getNotificationBackgroundColor = theme => NOTIFICATION_BACKGROUND_COLOR;